/**
 * CartListItem Component - Created by gustavomedina on 04/05/18.
 */
import * as React from 'react'
import MediaQuery from 'react-responsive'
import {
  Container,
  Image,
  ItemDetails,
  ItemDetailsHeader,
  ItemDetailsHeaderName,
  ItemDetailsHeaderPrice,
  ItemDetailsHeaderNameDetail,
  NameContainer,
  PriceContainer,
  BottomDivider,
  HeaderPriceDetailEmpty,
  RemoveButton,
  TicketDiv,
  TicketLink,
  CertificationButton,
  ImageContainer,
  CertificationButton2,
  ProCertifiedLabel,
  NotesDiv,
  EditNotes,
  EditIcon,
  ItemDetailsMobile,
} from './styledComponents'
import get from 'lodash/get'
import {
  CartItems,
  Message
} from '../../types/common'
import messages from './messages'

interface Props {
  formatMessage: (
    messageDescriptor: Message,
    params?: MessagePrice
  ) => string
  title: string
  productName: string
  description: string
  price: number
  image: string
  cartItem: CartItems
  notes: string
  proDesignId: string
  showPreviewLabel?: boolean
  designShortId?: string
  ticketCode: string
  ticketShortId: string
  itemIndex: number
  onlyRead?: boolean
  fromCart?: boolean
  fromApproval?: boolean
  ticketSolved?: boolean
  isProCertified?: boolean
  currentCurrency: string
  currencySymbol?: string
  history?: any
}

interface MessagePrice {
  symbol: string
  price: string
}

export class CartListItem extends React.Component<Props, {}> {
  gotToProductPage = () => {
    const { fromCart, history, onlyRead } = this.props
    if (!fromCart) {
      this.goToTicket()
      return
    }
    const {
      cartItem: {
        shortId,
        product: { id, yotpoId }
      },
    } = this.props

    if (onlyRead) {
      return
    }

    let productUrl = `/product?id=${id}&modelId=${yotpoId}`

    if (shortId) {
      productUrl = `/custom-product?id=${shortId}`
    }

    history.push(productUrl)
  }

  goToTicket = () => {
    const {
      history,
      ticketCode,
      ticketShortId,
      proDesignId,
      designShortId
    } = this.props
    if (ticketCode && ticketShortId) {
      const productUrl = proDesignId ? 
      `/approval?id=${proDesignId}&tab=testPrints` : `/print-approval?id=${designShortId}`
      history.push(productUrl)
    }
  }

  handleRemoveItem = () => {
    const { removeItem, cartItem } = this.props
    if (cartItem.shortId) {
      removeItem(cartItem.shortId)
    }
  }

  handleOpenNotes = () => {
    const { setOpenNotes, cartItem } = this.props
    if (cartItem.shortId) {
      setOpenNotes(cartItem.shortId)
    }
  }

  render() {
    const {
      title,
      price,
      productName,
      description,
      image,
      cartItem,
      onlyRead,
      fromCart,
      fromApproval,
      ticketSolved,
      currencySymbol,
      ticketCode,
      ticketShortId,
      designShortId,
      proDesignId,
      notes,
      isProCertified,
      showPreviewLabel,
      formatMessage,
    } = this.props

    const {
      code,
      createdAt,
    } = cartItem

    const mpnCode = get(cartItem, 'product.mpn', '')
    const symbol = currencySymbol || '$'

    const itemDetailsHeader = (
      <ItemDetailsHeader>
        <NameContainer>
          <ItemDetailsHeaderName>{title}</ItemDetailsHeaderName>
          <ItemDetailsHeaderNameDetail>
            {productName} {description}
          </ItemDetailsHeaderNameDetail>
          <ItemDetailsHeaderNameDetail>
            {code || mpnCode}
          </ItemDetailsHeaderNameDetail>
          <ItemDetailsHeaderNameDetail>
            {createdAt}
          </ItemDetailsHeaderNameDetail>
        </NameContainer>
        <PriceContainer>
          <ItemDetailsHeaderPrice>
            {`${symbol} ${(price || 0).toFixed(2)}`}
          </ItemDetailsHeaderPrice>
          <HeaderPriceDetailEmpty />
        </PriceContainer>
      </ItemDetailsHeader>
    )

    const renderView = (
      <MediaQuery minWidth={'641px'}>
        {(matches) => {
          if (matches) {
            return (
              <Container>
                <ImageContainer onClick={this.gotToProductPage}>
                  <Image
                    {...{ onlyRead }}
                    src={`${image}?p=${Math.random().toString(36).substr(2, 5)}`}
                    crossOrigin="anonymous"
                    crossorigin="anonymous"
                  />
                  {!fromCart && !showPreviewLabel &&
                    <CertificationButton>
                      {formatMessage(messages[fromApproval ? 'testPrintInProgress' : 'certificationInProgress'])}
                    </CertificationButton>
                  }
                  {!fromCart && showPreviewLabel && !fromApproval && (
                    isProCertified ?
                      <ProCertifiedLabel>
                        {formatMessage(messages.proCertified)}
                      </ProCertifiedLabel> :
                      <CertificationButton2>
                        {formatMessage(messages.preview)}
                      </CertificationButton2>
                    )
                  }
                  {!fromCart && showPreviewLabel && fromApproval && (
                    ticketSolved ?
                      <ProCertifiedLabel>
                        {formatMessage(messages.preview)}
                      </ProCertifiedLabel> :
                      <CertificationButton2>
                        {formatMessage(messages.testPrintInProgress)}
                      </CertificationButton2>
                  )}
                </ImageContainer>
                <ItemDetails>
                  {itemDetailsHeader}
                  {notes &&
                    <NotesDiv>
                      <EditIcon type="tag" />
                      {notes}
                    </NotesDiv>
                  }
                  {fromCart &&
                    <EditNotes onClick={this.handleOpenNotes}>
                      <EditIcon type="edit" />
                      {formatMessage(messages.editNote)}
                    </EditNotes>
                  }
                </ItemDetails>
                {fromCart && !fromApproval &&
                  <RemoveButton onClick={this.handleRemoveItem}>
                    {formatMessage(messages.remove)}
                  </RemoveButton>
                }
                {ticketCode && ticketShortId && false &&
                  <TicketDiv>
                    {formatMessage(messages.ticketPrint)}
                    <TicketLink 
                      href={proDesignId ? 
                        `/approval?id=${proDesignId}&tab=testPrints` : `/print-approval?id=${designShortId}`
                      }
                    >
                      JTP-{ticketCode ? ticketCode.toString().padStart(4, '0') : '-'}
                    </TicketLink>
                  </TicketDiv>
                }
              </Container>
            )
          } else {
            return (
              <Container>
                <ItemDetails>
                  <ImageContainer onClick={this.gotToProductPage}>
                    <Image
                      {...{ onlyRead }}
                      src={`${image}?p=${Math.random().toString(36).substr(2, 5)}`}
                      crossOrigin="anonymous"
                      crossorigin="anonymous"
                    />
                    {!fromCart && !showPreviewLabel &&
                      <CertificationButton>
                        {formatMessage(messages[fromApproval ? 'testPrintInProgress' : 'certificationInProgress'])}
                      </CertificationButton>
                    }
                    {!fromCart && showPreviewLabel && !fromApproval && (
                      isProCertified ?
                        <ProCertifiedLabel>
                          {formatMessage(messages.proCertified)}
                        </ProCertifiedLabel> :
                        <CertificationButton2>
                          {formatMessage(messages.preview)}
                        </CertificationButton2>
                      )
                    }
                    {!fromCart && showPreviewLabel && fromApproval && (
                      ticketSolved ?
                        <ProCertifiedLabel>
                          {formatMessage(messages.preview)}
                        </ProCertifiedLabel> :
                        <CertificationButton2>
                          {formatMessage(messages.testPrintInProgress)}
                        </CertificationButton2>
                    )}
                  </ImageContainer>
                  <ItemDetailsMobile>
                    {itemDetailsHeader}
                    {notes &&
                      <NotesDiv>
                        {notes}
                      </NotesDiv>
                    }
                    {fromCart &&
                      <EditNotes onClick={this.handleOpenNotes}>
                        <EditIcon type="edit" />
                        {formatMessage(messages.editNote)}
                      </EditNotes>
                    }
                  </ItemDetailsMobile>
                </ItemDetails>
                {fromCart &&
                  <RemoveButton onClick={this.handleRemoveItem}>
                    {formatMessage(messages.remove)}
                  </RemoveButton>
                }
                {ticketCode && ticketShortId && false &&
                  <TicketDiv>
                    {formatMessage(messages.ticketPrint)}
                    <TicketLink 
                      href={proDesignId ? 
                        `/approval?id=${proDesignId}&tab=testPrints` : `/print-approval?id=${designShortId}`
                      }
                    >
                      JTP-{ticketCode ? ticketCode.toString().padStart(4, '0') : '-'}
                    </TicketLink>
                  </TicketDiv>
                }
              </Container>
            )
          }
        }}
      </MediaQuery>
    )
    return (
      <div>
        {renderView}
        <BottomDivider />
      </div>
    )
  }
}

export default CartListItem



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/CartListItemPrint/index.tsx